<template>
    <resize-table
      :scroll="{ x:400, y: height-54 }"
      bordered
      :columns="formulaRawColumns"
      tableName="formulaRawColumns"
      :loading="rawListLoading"
      :data-source="list.records"
      :row-key="record => record.id"
      :pagination="false"
      :rowClassName="rowClassname"
    >
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 原料名称</span>
      <template slot="rawName" slot-scope="text,record">
        {{overseasFlag == '1' ? (record.aliasName || text) : text}}
      </template>
    <template v-for="(col,index) in ['minValue', 'maxValue']" slot-scope="text,record" :slot="col">
      <span v-if="record.isRawDelete == 1 || (record.isExtraProRaw == 1 && record.isDeleted == 1)" :key="col">
        {{ text ? Number(text).toFixed(3) : ''}}
      </span>
       <cell-editor
        v-else
        :item="record"
        :len="3" 
        :key="index" 
        :name="col"
        @blur="target => itemUpdate(target)" :text="text" :actions="update" />
    </template>
    <span
      v-for="twin in ['singUasgePer','taskUasgePer','maxApply', 'minApply','uasge', 'cost','productRawUasge','productRawPercentage', 'minLimitValue','maxLimitValue']"
      :slot="twin"
      slot-scope="text"
      :key="twin"
    >
        <span v-if="twin === 'cost'">{{ text ? Number(text).toFixed(3) : ''}}</span>
        <span v-else>{{ text || text === 0? Number(text).toFixed(3) : ''}}</span>
      </span>
      <template slot="option" slot-scope="text,record">
        <a-space v-if="record.editable">
          <a-button type="primary" size="small" @click="() =>saveHandle(record.id)" :loading="updateLoading" style="font-size:12px">保存</a-button>
          <a-button size="small" style="font-size:12px" @click="() => cancelHandle(record.id)">取消</a-button>
        </a-space>
        <span v-else class="save_class">
          <a-button size="small" type="link" @click="() => eidtorItem(record.id)">编辑</a-button>
        </span>
      </template>
    </resize-table>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue'
import { formulaMixins } from '../unitls'
export default {
  components: { CellEditor },
  mixins:[formulaMixins],
  data(){
    return{
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      list:{
        records:[]
      },
      rawListLoading:false,
      filled: true,
      cacheData: [],
    }
  },
  mounted(){
    this.getList()
  },
  watch:{
    formula(item){
      if(item.id) this.getList({taskFormulaId:item.id})
    },
    resRaw(val){
      if(val) this.getList()
    }
  },
  methods:{
    getFilterList(){
      let rawCurrentType = window.localStorage.getItem('rawCurrentType')
      if(rawCurrentType) {
        this.filterRaw(Number(rawCurrentType))
      }
    },
    changeColumns(){
      let formulaRawColumns = [...this.formulaRawColumns]
      if(this.filled){
        formulaRawColumns[0].fixed = 'left'
      }else{
        delete formulaRawColumns[0].fixed
      }
      this.setState({formulaRawColumns})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns()
      e = e || window.event;  
      if(e.stopPropagation) { //W3C阻止冒泡方法  
          e.stopPropagation();  
      } else {  
          e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    async filterRaw(val){
      // ① 默认填充所有原料； ② 拒绝原料：用量(吨) = 0.000的原料； ③ 组分原料：用量(吨) > 0.000的原料；
      // rawTypes:[ '所有原料','组分原料','拒绝原料' ],
      // const {data} = await this.getList()
      let list = JSON.parse(JSON.stringify(this.cacheData))
      if(list && list.length){
        if(val == 0) this.list.records =  list
        if(val == 1) this.list.records =  list.filter(i => i.uasge > 0)
        if(val == 2) this.list.records =  list.filter(i => !i.uasge)
      }
    },

    rowClassname(record){
      let {uasge,isRawDelete,isDeleted,isExtraProRaw} = record || {}
      return  isRawDelete == '1' || (isExtraProRaw == 1 && isDeleted == 1) ? 'selectGary' : (uasge == 0 ? 'selectRows' : '')
    },
    
    itemUpdate(item){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const targets = newData.filter(i => item.rawId == i.rawId)[0]
      const targetCache = newCacheData.filter(i => i.rawId === item.rawId)[0]
      if (targets) {
        Object.assign(targetCache, item)
        Object.assign(targets, item)
        this.cacheData = newCacheData
        this.list.records = newData
      }
    },
    async update(data){
      let {rawName,...newData} = data || {}
      console.log(rawName)
      return this.fetchPost({
        showMessage: false,
        actions:this.formulataskformularawUpdate,
        data: newData,
      })
    },
    async getList(arg={}){
      let res = await this.fetchGet({
        actions:this.selectTaskFormulaRawByTaskFormulaId,
        name:'list',
        loading:"rawListLoading",
        data:{
          current:1,
          size: 1000,
          taskFormulaId:this.formula.id,
          factoryId:this.factoryId,
          ...arg
        }
      })
      let {success,data} = res || {}
      if(success){
        if(data.records){
          data.records = data.records.filter(el => el.isDeleted != 1 || (el.isRawDelete == 1 || el.isExtraProRaw == 1))
        }
        this.list = data
        this.cacheData = JSON.parse(JSON.stringify(data.records))
      }
      this.getFilterList()
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .selectRows{
    background-color: rgba(255, 206, 163, 0.1) !important;
    background-color:#fff9e5 !important;
  }
  ::v-deep .selectGary{
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
</style>